"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.INDUSTRY_OPTIONS = void 0;
// Only industry supported today — kept as a dropdown so adding more later doesn't change the field's shape.
var INDUSTRY_OPTIONS = ["Cannabis"];
exports.INDUSTRY_OPTIONS = INDUSTRY_OPTIONS;
